import omitBy from 'lodash/omitBy';
import useSWR from 'swr';

import { ILeaderboardForm } from 'containers/Leaderboards/interface';
import { IDetailResponse, IPaginatedResponse } from 'utils/types';

import { fetcher } from './utils';

export const useLeaderboard = (id?: number | string | null) => {
  const { data, isLoading, error, mutate, isValidating } = useSWR<
    IDetailResponse<ILeaderboardForm>
  >(id ? `/v4/dash/leaderboards/${id}` : null, fetcher);

  return { data: data?.data, isLoading, error, mutate, isValidating };
};

export const useLeaderboardList = (params: Record<string, any>) => {
  const sanitizedParams = params ? omitBy(params, value => value === undefined) : undefined;
  const { data, isLoading, error, mutate, isValidating } = useSWR<
    IPaginatedResponse<ILeaderboardForm>
  >({ url: '/v4/dash/leaderboards', params: sanitizedParams }, fetcher);

  return { data: data?.data, meta: data?.meta, isLoading, error, mutate, isValidating };
};
